import React, { useState, useEffect } from 'react';
import './index.css';
import ruppezy_icon from "../../assets/icons/rupeezy_icon.svg";
import tv_terminal_icon from "../../assets/icons/tv_terminal.svg";
import vortex_icon from "../../assets/icons/vortex.svg";
import dock_icon from "../../assets/icons/dock.svg";
import rupeezy_icon_with_name from "../../assets/icons/rupeezy.svg";
import aero_icon from "../../assets/icons/aero.svg"; // Add your aero icon path
import { useNavigate } from 'react-router-dom';

interface AuthLoginData {
    refreshToken: string;
    ssoToken: string;
    deviceId: string;
    tradingActive: boolean;
}

const RupeezyLogin: React.FC = () => {
    const navigate = useNavigate();
    const [ssoToken, setSsoToken] = useState<string | null>(null);

    useEffect(() => {
        const authLoginData = localStorage.getItem("AUTH_LOGIN");
        if (authLoginData) {
            try {
                const parsedData: AuthLoginData = JSON.parse(authLoginData);

                setSsoToken(parsedData.ssoToken);
            } catch (error) {
                console.error("Error parsing AUTH_LOGIN data:", error);
            }
        } else {
            console.error("No SSO token found in local storage");
        }
    }, []);

    const handleNavigateWithStoredToken = () => {
        if (ssoToken) {
            const baseUrl = process.env.REACT_APP_APP_URL || 'https://flow.rupeezy.dev';
            const path = '/tvTerminal/sso';
            const params = new URLSearchParams({
                sso_auth_token: ssoToken,
                version: 'v2'
            });
            const fullRedirectUrl = `${baseUrl}${path}?${params.toString()}`;
            console.log("Redirecting to:", fullRedirectUrl);
            window.open(fullRedirectUrl, "_self");
        } else {
            window.open('/', "_self");
        }
    };

    const handleNavigateWithStoredTokenForWeb = () => {
        if (ssoToken) {
            const baseUrl = process.env.REACT_APP_APP_URL || 'https://flow.rupeezy.dev';
            const path = '/web';
            const params = new URLSearchParams({
                sso_auth_token: ssoToken,
                version: 'v2'
            });
            const fullRedirectUrl = `${baseUrl}${path}?${params.toString()}`;
            console.log("Redirecting to:", fullRedirectUrl);
            window.open(fullRedirectUrl, "_self");
        } else {
            window.open('/', "_self");
        }
    };

    const handleNavigateWithStoredTokenForDock = () => {
        if (ssoToken) {
            const baseUrl = process.env.REACT_APP_DOCK_BASE_URL || 'https://dock.rupeezy.dev';
            const path = '/dashboard';
            const params = new URLSearchParams({
                sso_auth_token: ssoToken,
                version: 'v2'
            });
            const fullRedirectUrl = `${baseUrl}${path}?${params.toString()}`;
            console.log("Redirecting to:", fullRedirectUrl);
            window.open(fullRedirectUrl, "_self");
        } else {
            window.open('/', "_self");
        }
    };

    const handleNavigateWithStoredTokenForAero = () => {
        if (ssoToken) {
            const baseUrl = process.env.REACT_APP_AERO_URL || 'https://aero.rupeezy.in/AeroSso';
            const path = '/login';
            const params = new URLSearchParams({
                token: ssoToken,
                applicationId: process.env.REACT_APP_APPLICATION_ID_FOR_AERO || '',
                ucc: "",
                data: ""
            });
            const fullRedirectUrl = `${baseUrl}${path}?${params.toString()}`;
            console.log("Redirecting to:", fullRedirectUrl);
            window.open(fullRedirectUrl, "_self");
        } else {
            window.open('/', "_self");
        }
    };

    return (
        <div className="rupeezy-container">
            <div className="login-container">
                <div className="login-card">
                    <div className="logo-section">
                        <img src={rupeezy_icon_with_name} alt="Rupeezy Logo" />
                    </div>

                    <div className="login-content">
                        <h3 className="login-title">Login</h3>
                        <p className="login-subtitle">Choose the product you want to access.</p>

                        <div className="product-options">
                            <button
                                autoFocus
                                type="button"
                                className="product-card rupeezy-web"
                                onClick={handleNavigateWithStoredTokenForWeb}
                            >
                                <div className="product-icon">
                                    <img src={ruppezy_icon} alt="Rupeezy Web Icon" />
                                </div>
                                <h4 className="product-title">Rupeezy Web</h4>
                                <p className="product-description">
                                    Trade & invest, track portfolios, and manage your investments.
                                </p>
                            </button>

                            <button
                                type="button"
                                className="product-card trading-view"
                                onClick={handleNavigateWithStoredToken}
                            >
                                <div className="product-icon">
                                    <img src={tv_terminal_icon} alt="TradingView Icon" />
                                </div>
                                <h4 className="product-title">TradingView</h4>
                                <p className="product-description">
                                    View live market data, analytics, real-time updates, and advanced charts.
                                </p>
                            </button>

                            <button
                                type="button"
                                className="product-card dock"
                                onClick={handleNavigateWithStoredTokenForDock}
                            >
                                <div className="product-icon">
                                    <img src={dock_icon} alt="Dock Icon" />
                                </div>
                                <h4 className="product-title" style={{ color: "black" }}>Dock</h4>
                                <p className="product-description" style={{ color: "black" }}>
                                    Dashboard to track P&L, view trade history, manage account details, and more.
                                </p>
                            </button>

                            {/* <div 
                                className="product-card aero"
                                onClick={handleNavigateWithStoredTokenForAero}
                            >
                                <div className="discontinuing-banner">Discontinuing Soon</div>
                                <div className="product-icon">
                                    <img src={aero_icon} alt="Aero Icon" />
                                </div>
                                <h4 className="product-title">Aero</h4>
                                <p className="product-description">
                                    Aero is discontinuing soon. Try <b>Rupeezy Web</b> for faster and better experience.
                                </p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RupeezyLogin;
